import { ComponentWithProperties } from '@simonbackx/vue-app-navigation';
import { DataPermissionsSettings, PermissionLevel } from '@stamhoofd/structures';
import { markRaw } from 'vue';
import MemberStepView from '#members/MemberStepView.vue';
import type { NavigationActions } from '../../../types/NavigationActions';
import EditMemberDataPermissionsBox from '../../components/edit/EditMemberDataPermissionsBox.vue';
import type { EditMemberStep, MemberStepManager } from '../MemberStepManager';
import type { MemberSharedStepOptions } from './MemberSharedStepOptions';

const maxOutdatedTime = 60 * 1000 * 60 * 24; // 1 day

export class MemberDataPermissionStep implements EditMemberStep {
    options: MemberSharedStepOptions;

    constructor(options: MemberSharedStepOptions) {
        this.options = options;
    }

    getName(manager: MemberStepManager) {
        const settings = manager.member.platform.config.dataPermission ?? DataPermissionsSettings.create({});
        return settings.title;
    }

    isEnabled(manager: MemberStepManager) {
        const member = manager.member;
        const details = member.patchedMember.details;

        if (!member.isPropertyEnabled('dataPermission', {
            checkPermissions: manager.context.user
                ? {
                        level: PermissionLevel.Write,
                        user: manager.context.user,
                    }
                : undefined,
        })) {
            return false;
        }

        if (details.dataPermissions === null) {
            return true;
        }

        if (this.options.outdatedTime) {
            if (details.dataPermissions.value === false && details.dataPermissions.isOutdated(Math.min(this.options.outdatedTime, maxOutdatedTime))) {
                return true;
            }
        }

        return false;
    }

    getComponent(manager: MemberStepManager): ComponentWithProperties {
        return new ComponentWithProperties(MemberStepView, {
            title: manager.member.platform.config.dataPermission?.title ?? DataPermissionsSettings.defaultTitle,
            member: manager.member,
            component: markRaw(EditMemberDataPermissionsBox),
            saveText: $t(`%16p`),
            saveHandler: async (navigate: NavigationActions) => {
                await manager.saveHandler(this, navigate);
            },
        });
    }
}
